import React, { useContext } from 'react';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

function Profile() {
  const { loggedUser } = useContext(AuthenticatedUserContext);

  return (
    <ResponsiveLayout title="Expedition overview">
      <title>Ringil | Authentication info</title>
      <div>
        <h1>Profile</h1>
        <p>This is the profile page.</p>

        <pre>{JSON.stringify(loggedUser || {}, null, 2)}</pre>
      </div>
    </ResponsiveLayout>
  );
}

export default withAuthenticationRequired(Profile);
